// Module
var code = "<div class=\"vui-content tw-w-full tw-block\">\n    <div ng-class=\"{'container': !$ctrl.fullScreen}\" ng-transclude></div>\n</div>\n";
// Exports
module.exports = code;